export default "__VITE_ASSET__CEKK66Pj__"